<div class="admin-page">
  <div class="admin-header">
    <h1 class="page-title">Admin</h1>
  </div>

  <div class="admin-tab-bar">
    <a class="admin-tab" routerLink="preferences" routerLinkActive="admin-tab-active">Preferences</a>
    <a class="admin-tab" routerLink="customers" routerLinkActive="admin-tab-active" *ngIf="isAdmin">Customers</a>
    <a class="admin-tab" routerLink="devices" routerLinkActive="admin-tab-active" *ngIf="isAdmin">Devices</a>
    <a class="admin-tab" routerLink="users" routerLinkActive="admin-tab-active" *ngIf="isAdmin">Users</a>
  </div>

  <div class="admin-content">
    <router-outlet></router-outlet>
  </div>
</div>
